import React from 'react';
import {
  Alert, Button, DrawerBody, DrawerFooter, Link, Typography
} from '@one-thd/sui-atomic-components';
import proptypes from 'prop-types';
import { extend } from '@thd-nucleus/data-sources';
import { AiPromptSuccessSection } from '../../common/ai-list-builder/AiPromptSuccessSection';
import { describeAddedItems } from '../../AddToHelpers';
import { ItemIconStrip } from '../../common/item-icon-strip/ItemIconStrip';

const {
  string, func, shape, arrayOf, oneOfType, number
} = proptypes;

const AddToProjectSuccess = ({
  selectedProject,
  selectedGroup,
  selectedGroupId,
  onClose,
  products = []
}) => {
  const { projectId, projectName } = selectedProject;

  const handleGroupLinkClick = () => {
    onClose('ok');
    window.location.href = `/projects/${projectId}#group=${selectedGroupId?.current || ''}`;
  };

  const isUnassignedGroup = !selectedGroup || selectedGroup === 'Unassigned';
  const addedSummary = describeAddedItems(products) || (products.length > 1 ? 'Items' : 'Item');

  return (
    <>
      <DrawerBody>
        <Alert status="success" size="large" data-testid="add-to-success-alert">
          <Typography variant="body-sm">
            {addedSummary} successfully added to&nbsp;
            <Link title={projectName} href={`/projects/${projectId}`} className="sui-text-sm sui-underline">
              {projectName}
            </Link>
            {!isUnassignedGroup && (
              <>
                &nbsp;in group&nbsp;
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                <Link component="button" onClick={handleGroupLinkClick} className="sui-text-sm sui-underline">
                  {selectedGroup}
                </Link>
              </>
            )}
          </Typography>
        </Alert>

        <ItemIconStrip items={products} className="sui-mt-5 sui-mb-5" />

        <AiPromptSuccessSection
          addType="project"
          entityId={projectId}
          entityIdField="projectId"
          redirectUrl={`/projects/${projectId}`}
          title="Complete your project with AI"
          description={(
            'Describe your project or paste a list of materials. '
            + 'We\'ll use your input to add all the items you might need to your project!'
          )}
        />
      </DrawerBody>
      <DrawerFooter>
        <Button
          fullWidth
          variant="secondary"
          onClick={() => { onClose('ok'); }}
        >
          Close
        </Button>
      </DrawerFooter>
    </>
  );
};

AddToProjectSuccess.propTypes = {
  selectedProject: shape({
    projectId: string,
    projectName: string
  }).isRequired,
  selectedGroup: string,
  selectedGroupId: shape({
    current: string
  }),
  onClose: func.isRequired,
  products: arrayOf(shape({
    itemId: string,
    purchaseIntent: string,
    itemType: string,
    quantity: oneOfType([string, number])
  }))
};

AddToProjectSuccess.defaultProps = {
  selectedGroup: null,
  selectedGroupId: { current: '' },
  products: []
};

AddToProjectSuccess.displayName = 'AddToProjectSuccess';

AddToProjectSuccess.dataModel = extend(AiPromptSuccessSection.dataModel, ItemIconStrip);

export { AddToProjectSuccess };
